import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import {
    GetOcrTradesHistoryRequestModel,
    GetOcrTradesHistoryResponseModel,
} from "@/features/accounts/ocr/services/get-trades-history-model";

export class GetOcrTradesHistoryApi {
    /**
     * OCR取込履歴取得API
     */
    public getOcrTradesHistory = async (
        param: GetOcrTradesHistoryRequestModel,
    ): Promise<GetOcrTradesHistoryResponseModel> => {
        const path = `/api/ocraccounts/tradeshistory`;
        const res = await ApiClient.instance.get<GetOcrTradesHistoryResponseModel>({
            path: path,
            params: param as NonNullable<unknown>,
        });

        if (res.ok === false) {
            throw MoneyLinkException.fromServer({ response: res });
        }

        return res.body;
    };
}
